import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES, TABS } from '../../../../../common/constants';

const CouponTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [activeTabKey, setActiveTabKey] = useState(TABS?.IN?.key);

  const tabList = [
    {
      key: TABS?.COUPONS?.key,
      label: TABS?.COUPONS?.label,
      children,
    },
    {
      key: TABS?.SPECIAL_COUPONS?.key,
      label: TABS?.SPECIAL_COUPONS?.label,
      children,
    },
  ];

  useEffect(() => {
    if (location?.pathname?.includes(ROUTES?.COUPON)) {
      setActiveTabKey(TABS?.COUPONS?.key);
    }
    if (location?.pathname?.includes(ROUTES?.SPECIAL_COUPON)) {
      setActiveTabKey(TABS?.SPECIAL_COUPONS?.key);
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTabKey(key);
    switch (key) {
      case TABS?.COUPONS?.key:
        history?.push(`${ROUTES?.OFFERS}${ROUTES?.COUPON}`);
        break;
      case TABS?.SPECIAL_COUPONS?.key:
        history?.push(`${ROUTES?.OFFERS}${ROUTES?.SPECIAL_COUPON}`);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="card-container mobile-card-main">
        <Tabs
          activeKey={activeTabKey}
          type="card"
          className="full-width"
          onChange={(key) => onTabChange(key)}
          items={tabList}
          destroyInactiveTabPane
        />
      </div>
    </>
  );
};

export default CouponTabs;
